//  @flow

import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
// $Ignore
import { connect } from 'react-redux';
// $Ignore
import { bindActionCreators } from 'redux';

import InputManager from '../../Components/InputManager';
import FormManager from '../../Components/FormManager';
import Button from '../../Components/Button';

import { validateEmail, validateMobile } from '../../helpers/helper';
import { createStudent } from '../../actions/student';
import { CourseLevel } from '../../GlobalTypes';
import { acitavteNotification } from '../../actions/Notification';

import RootContext from '../../Context/RootContext';

import './style.css';

const ENROLL_COURSE = 'enrolled';

const currentStatus = {
  Studying: 'studying',
  Working: 'working',
  'Looking for a job': 'looking_for_job',
  'Still figuring out': 'figuring_out'
};

const hearAboutUs = {
  LinkedIn: 'linkedin',
  Facebook: 'facebook',
  Instagram: 'instagram',
  Email: 'email',
  YouTube: 'youtube',
  'We called you': 'we_called_you',
  'From a Webinar Organized by your Campus': 'webinar',
  'Word of Mouth': 'word_of_mouth',
  Article: 'article',
  'Search Engine': 'search_engine',
  Reddit: 'reddit',
  HackerEarth: 'hackerearth',
  'Geeks for Geeks': 'geeks_for_geeks',
  Others: 'others'
};

const BillLabel = memo(({ title, description }) => (
  <div className="bill-label-box">
    <span className="bill-label-title">{title}</span>
    <span className="bill-label-description">{description}</span>
  </div>
));

type callbackParams = {
  success: boolean,
  razorpayId: string
};
type FormProps = {
  courseLevels: Array<CourseLevel>,
  courseName: string,
  acitavteNotification: (title: string, description: string) => void,
  currentCourseDuration: string,
  studentId: string,
  createStudent: (
    name: string,
    email: string,
    phone: string,
    dob: string,
    gender: string,
    city: string,
    hear_about_us: string,
    current_status: string,
    callback?: (param: callbackParams) => void
  ) => void,
  orderId: string,
  closeModal: () => void
};

type FormState = {
  name: string,
  email: string,
  phone: string,
  dob: string,
  gender: string,
  city: string,
  hear_about_us: string,
  current_status: string,
  courseDurationId: string,
  price: string,
  progressData: {
    progressType: string,
    loading: boolean
  }
};

class newForm extends React.PureComponent<FormProps, FormState> {
  static contextType = RootContext;

  constructor(props: FormProps) {
    super(props);
    this.state = {
      name: '',
      email: '',
      phone: '',
      dob: '',
      gender: '',
      city: '',
      hear_about_us: '',
      current_status: '',
      courseDuration: '',
      courseDurationId: '',
      price: '',
      progressData: {
        progressType: '',
        loading: false
      }
    };
  }

  componentDidMount() {
    this.setCoursePrice();
    const addScripts = this.context;
    if (typeof addScripts === 'function') {
      addScripts();
    }
  }

  componentDidUpdate(prevProps: FormProps) {
    if (prevProps.currentCourseDuration !== this.props.currentCourseDuration) {
      this.setCoursePrice();
    }
  }

  toggleProgress = (status = false, type = '') => {
    this.setState(prevState => ({
      progressData: {
        progressType: type || prevState.progressData.progressType,
        loading: status
      }
    }));
  };

  onChange = (id, val) => {
    if (id === 'hear_about_us') {
      this.setState({
        [id]: hearAboutUs[val]
      });
    } else if (id === 'current_status') {
      this.setState({
        [id]: currentStatus[val]
      });
    } else {
      this.setState({
        [id]: val
      });
    }
  };

  onRadioChange = e => {
    this.setState({
      [e.target.name]: e.target.id
    });
  };

  onCurrentStatusChange = (id, val) => {
    switch (this.state.current_status) {
      case 'studying':
        this.setState({
          ['student_studying_profile']: {
            ...this.state.student_studying_profile,
            [id]: val
          }
        });
        break;
      case 'working':
        this.setState({
          ['student_working_profile']: {
            ...this.state.student_working_profile,
            [id]: val
          }
        });
        break;
      case 'looking_for_job':
        this.setState({
          ['student_looking_job_profile']: {
            ...this.state.student_looking_job_profile,
            [id]: val
          }
        });
        break;
      case 'figuring_out':
        this.setState({
          ['student_confused_profile']: {
            ...this.state.student_confused_profile,
            [id]: val
          }
        });
    }
  };

  onDurationChange = (id, value) => {
    if (!value) return;
    this.setState({ [id]: value }, this.setCoursePrice);
  };

  setCoursePrice = () => {
    const duration =
      this.state.courseDuration || this.props.currentCourseDuration;
    const course = this.props.courseLevels.find(item => item.name === duration);
    if (course) {
      this.setState({
        courseDurationId: course.id,
        price: course.amount > 0 ? String(course.amount / 100) : 0
      });
    }
  };

  invalidText = (val: string) => val.trim().length < 3;

  validateEmail = (val: string) => !validateEmail(val.trim());

  validatePhone = (val: string) => !validateMobile(val.trim());

  invalidSemester = (val: string) => Number(val) < 1;

  invalidAmount = (val: string) => !val;

  onSubmit = async (data, resetForm) => {
    const { t } = this.props;

    try {
      const {
        name,
        email,
        phone,
        dob,
        gender,
        city,
        hear_about_us,
        current_status,
        student_studying_profile,
        student_working_profile,
        student_looking_job_profile,
        student_confused_profile,
        courseDurationId
      } = this.state;
      this.toggleProgress(true, ENROLL_COURSE);
      await this.props.createStudent(
        name,
        email,
        phone,
        dob.replace(/-/g, '/'),
        gender,
        city,
        hear_about_us,
        current_status,
        student_studying_profile,
        student_working_profile,
        student_looking_job_profile,
        student_confused_profile,
        courseDurationId
      );
      const successMessage = `You have successfully registered for our course.
You will be contacted by our team soon. `;
      this.toggleProgress(false);
      this.props.acitavteNotification(
        t('coursebuySuccess'),
        successMessage,
        true
      );
      this.onModalClose();
    } catch (err) {
      this.toggleProgress(false);
      this.setErrorNotification(err);
    }
  };

  setErrorNotification = (error = '') => {
    const { t } = this.props;
    const errorMessage =
      error && typeof error === 'string' ? error : t('coursebuyFailedMsg');
    this.toggleProgress(false);
    this.props.acitavteNotification(t('coursebuyFailed'), errorMessage);
  };

  onModalClose = () => {
    this.props.closeModal();
  };

  ConditionalForm = current_status => {
    const { t } = this.props;
    switch (current_status) {
      case 'studying':
        return (
          <div className="form-field-container">
            <div className="form-field">
              <InputManager
                id="college_name"
                title={t('inputCollege')}
                validate={this.invalidText}
                required={true}
                emptyText={t('collegeEmptyText')}
                invalidText={t('collegeInvalidText')}
                onChange={this.onCurrentStatusChange}
                className="registration-field"
              />
            </div>
            <div className="form-field">
              <InputManager
                id="semester"
                title={t('inputSemester')}
                placeholder="Choose semester"
                type="select"
                options={['1', '2', '3', '4', '5', '6', '7', '8', '8+']}
                validate={this.invalidSemester}
                required={true}
                emptyText={t('semEmptyText')}
                invalidText={t('semInvalidText')}
                onChange={this.onCurrentStatusChange}
                className="registration-field"
              />
            </div>
            <div className="form-field">
              <InputManager
                id="stream"
                title={t('inputStream')}
                validate={this.invalidText}
                required={true}
                emptyText={t('streamEmptyText')}
                invalidText={t('streamInvalidText')}
                onChange={this.onCurrentStatusChange}
                className="registration-field"
              />
            </div>

            <p className="field-title">
              Have you ever been in core team of fest committee/student council
              in your college?
            </p>
            <div className="radio">
              <input
                type="radio"
                name="core_team_presence"
                value="yes"
                className="radio-input"
                id="yes"
                onChange={this.onRadioChange}
              />
              <label className="radio-label" for="yes">
                Yes
              </label>
              <input
                type="radio"
                name="core_team_presence"
                value="no"
                className="radio-input"
                id="no"
                onChange={this.onRadioChange}
              />
              <label className="radio-label" for="no">
                No
              </label>
            </div>
          </div>
        );

      case 'working':
        return (
          <div className="form-field-container">
            <div className="form-field">
              <InputManager
                id="company_name"
                title={t('inputOrganization')}
                validate={this.invalidText}
                required={true}
                emptyText={t('organizationEmptyText')}
                invalidText={t('organizationInvalidText')}
                onChange={this.onCurrentStatusChange}
                className="registration-field"
              />
            </div>
            <div className="form-field">
              <InputManager
                id="designation"
                title={t('inputDesignation')}
                validate={this.invalidText}
                required={true}
                emptyText={t('designationEmptyText')}
                invalidText={t('designationInvalidText')}
                onChange={this.onCurrentStatusChange}
                className="registration-field"
              />
            </div>
          </div>
        );

      case 'looking_for_job':
      case 'figuring_out':
        return (
          <div className="text-area-field">
            <InputManager
              id="ideal_job_description"
              title={t('inputJobDescription')}
              validate={this.invalidText}
              required={true}
              type="textarea"
              emptyText={t('jobDescriptionEmptyText')}
              invalidText={t('jobDescriptionInvalidText')}
              onChange={this.onCurrentStatusChange}
              className="registration-text-area-field"
            />
          </div>
        );
    }
  };

  render = () => {
    const { t } = this.props;
    const {
      name,
      email,
      phone,
      dob,
      gender,
      city,
      hear_about_us,
      current_status,
      price,
      progressData
    } = this.state;
    const { progressType, loading } = progressData;
    return (
      <FormManager className="form-box" onSubmit={this.onSubmit}>
        <div className="form-heading">
          <span>{t('courseRegistration')}</span>
        </div>
        <div className="form-inner-box">
          <div className="form-field">
            <InputManager
              id="name"
              title={t('inputNameTitle')}
              validate={this.invalidText}
              required={true}
              emptyText={t('nameEmptyText')}
              invalidText={t('nameInvalidText')}
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <InputManager
              id="email"
              title={t('inputEmailTitle')}
              validate={this.validateEmail}
              required={true}
              emptyText={t('emailEmptyText')}
              invalidText={t('emailInvalidText')}
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <InputManager
              id="phone"
              title={t('inputPhoneTitle')}
              validate={this.validatePhone}
              required={true}
              type="tel"
              emptyText={t('phoneEmptyText')}
              invalidText={t('phoneInvalidText')}
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <InputManager
              id="dob"
              title={t('inputDobTitle')}
              required={true}
              type="date"
              emptyText={t('dobEmptyText')}
              invalidText={t('dobInvalidText')}
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <div className="field-title">Gender</div>
            <div className="radio">
              <input
                type="radio"
                name="gender"
                value="male"
                className="radio-input"
                id="male"
                onChange={this.onRadioChange}
              />
              <label className="radio-label" for="male">
                Male
              </label>
              <input
                type="radio"
                name="gender"
                value="female"
                className="radio-input"
                id="female"
                onChange={this.onRadioChange}
              />
              <label className="radio-label" for="female">
                Female
              </label>
              <input
                type="radio"
                name="gender"
                value="transgender"
                className="radio-input"
                id="transgender"
                onChange={this.onRadioChange}
              />
              <label className="radio-label" for="transgender">
                Transgender
              </label>
            </div>
          </div>

          <div className="form-field">
            <InputManager
              id="city"
              title={t('inputCityTitle')}
              validate={this.invalidText}
              required={true}
              type="text"
              emptyText={t('cityEmptyText')}
              invalidText={t('cityInvalidText')}
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <InputManager
              id="hear_about_us"
              placeholder="Select"
              title={t('inputHearAboutUsTitle')}
              required={true}
              type="select"
              options={Object.keys(hearAboutUs).map(key => key)}
              emptyText="required"
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          <div className="form-field">
            <InputManager
              id="current_status"
              placeholder="Select"
              title={t('inputOccupationTitle')}
              required={true}
              type="select"
              options={Object.keys(currentStatus).map(key => key)}
              emptyText="required"
              onChange={this.onChange}
              className="registration-field"
            />
          </div>

          {this.state.current_status &&
            this.ConditionalForm(this.state.current_status)}

          <div className="line-area" />

          <div className="bill-row bill-course">
            <span className="bill-row-course">{t('courseinfoTitle')}:</span>
            <span>{this.props.courseName}</span>
          </div>

          <div className="bill-row">
            <span className="bill-row-duration">
              {t('courseinfoDuration')}:
            </span>

            <div className="bill-row-item">
              <InputManager
                id="courseDuration"
                placeholder="Select"
                type="select"
                options={this.props.courseLevels.map(item => item.name)}
                defaultValue={this.props.currentCourseDuration}
                validate={this.invalidAmount}
                onChange={this.onDurationChange}
                required={true}
                emptyText="required"
                className="registration-field"
              />
            </div>
          </div>

          <div className="bill-row bill-price">
            <span className="bill-row-price">{t('coursePrice')}:</span>
            <span>
              {t('rupeeSign')} {price}
            </span>
          </div>

          <div className="form-action-row">
            <Button
              disabled={loading}
              loading={progressType === ENROLL_COURSE && loading}
              type="submit"
              primaryRegistration
              text={t('bookSeat')}
            />
          </div>
        </div>
      </FormManager>
    );
  };
}

const mapStateToProps = store => ({
  studentId: store.student.id,
  orderId: store.payment.orderId
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createStudent,
      acitavteNotification
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(newForm));



// WEBPACK FOOTER //
// ./src/Pages/Course/CourseBuyForm.js